import React from "react";
import { fmtNum } from "../lib/api";

export default function StatCard({ label, value, sub, icon: Icon, tone = "default", testId }) {
  const tones = {
    default: "bg-[#e6f3ec] text-[#0e6b4f]",
    blue: "bg-[#e0efff] text-[#1e4ea8]",
    pink: "bg-[#ffe4ec] text-[#a8256a]",
    amber: "bg-[#fff2d6] text-[#8a5b00]",
    slate: "bg-[#e6ecec] text-[#334b48]",
    accent: "bg-[#d1fae5] text-[#065f46]",
  };
  return (
    <div className="stat-card" data-testid={testId}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="stat-label">{label}</div>
          <div className="stat-value">{typeof value === "number" ? fmtNum(value) : (value ?? "-")}</div>
          {sub && <div className="stat-sub">{sub}</div>}
        </div>
        {Icon && (
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${tones[tone]}`}>
            <Icon size={19} strokeWidth={2.2} />
          </div>
        )}
      </div>
    </div>
  );
}
